import type { ICommand } from '@model-framework/command';
import type { LinkKey } from '@view-model/domain/key';
import type { LinkEntity, LinkName } from '../domain';
import { LinkEntityOperation } from '../adapter/LinkEntityOperation';
import type { ViewModelEntity } from '@view-model/domain/view-model';

export class LinkNameUpdateCommand implements ICommand {
  constructor(
    private readonly viewModel: ViewModelEntity,
    private readonly entityOperation: LinkEntityOperation,
    private readonly key: LinkKey,
    private readonly fromValue: LinkName,
    private readonly toValue: LinkName
  ) {}

  do(): void {
    const link = LinkEntityOperation.getLink(this.key, this.viewModel);
    if (!link) return;

    this.entityOperation.save(link.withName(this.toValue));
  }

  undo(): void {
    this.changeValue(this.toValue, this.fromValue);
  }

  redo(): void {
    this.changeValue(this.fromValue, this.toValue);
  }

  async canUndo(): Promise<boolean> {
    return !!this.retrieveLink(this.toValue);
  }

  async canRedo(): Promise<boolean> {
    return !!this.retrieveLink(this.fromValue);
  }

  private changeValue(fromValue: LinkName, toValue: LinkName): void {
    const link = this.retrieveLink(fromValue);
    if (!link) return;

    this.entityOperation.save(link.withName(toValue));
  }

  private retrieveLink(fromValue: LinkName): LinkEntity | null {
    return LinkEntityOperation.findLink({
      key: this.key,
      isTarget: (link: LinkEntity) => link.name.isEquals(fromValue),
      viewModel: this.viewModel,
    });
  }
}
